import { REQUEST_TRACE_ID_HEADER, REQUEST_TRACE_TIME_STAMP_HEADER, REQUEST_TRACE_TIME_STRING_HEADER } from '@my-backoffice/app/shared/constants/http-trace.constants';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { v4 as uuidv4 } from 'uuid';

@Injectable()
export class RequestTraceInterceptor implements HttpInterceptor {
  public intercept<T>(request: Readonly<HttpRequest<T>>, next: Readonly<HttpHandler>): Observable<HttpEvent<T>> {
    const nextHeaders: Record<string, string> = {};
    const nowMs: number = Date.now();

    // Only fill missing trace headers; keep existing values from caller/previous interceptors/retry replays.
    if (!request.headers.has(REQUEST_TRACE_ID_HEADER)) {
      nextHeaders[REQUEST_TRACE_ID_HEADER] = uuidv4().replace(/-/g, '');
    }

    if (!request.headers.has(REQUEST_TRACE_TIME_STAMP_HEADER)) {
      nextHeaders[REQUEST_TRACE_TIME_STAMP_HEADER] = nowMs.toString();
    }

    if (!request.headers.has(REQUEST_TRACE_TIME_STRING_HEADER)) {
      nextHeaders[REQUEST_TRACE_TIME_STRING_HEADER] = this._toUtc8String(nowMs);
    }

    return Object.keys(nextHeaders).length === 0 ? next.handle(request) : next.handle(request.clone({ setHeaders: nextHeaders }));
  }

  private _toUtc8String(timestampMs: number): string {
    const UTC8_OFFSET_MS = 8 * 60 * 60 * 1000;

    return new Date(timestampMs + UTC8_OFFSET_MS).toISOString().replace('Z', '+08:00');
  }
}
